import React from 'react';

const About = ({ onOpenForm }) => {
  return (
    <section id="sobre" className="py-16 bg-neutral-lightest">
      <div className="container mx-auto px-4">
        {/* Pitch de venda em destaque */}
        <div className="bg-primary/5 p-8 rounded-lg shadow-medium border border-primary/10 mb-16 text-center">
          <h2 className="text-2xl md:text-3xl font-sans font-bold mb-4 text-primary">
            "Eu ajudo médicos que estão começando na área de emagrecimento e reposição hormonal a ganharem segurança nas suas condutas, entregarem resultados consistentes, fidelizando o paciente e aumentando seu faturamento."
          </h2>
          <a 
            href="https://pt.surveymonkey.com/r/R7CD6CV"
            target="_blank" rel="noopener noreferrer"
            className="mt-6 inline-block bg-secondary hover:bg-secondary-light text-primary-dark font-bold py-3 px-8 rounded-full text-center transition-colors duration-300 shadow-soft"
          >
            Quero participar da Mentoria
          </a>
        </div>
        
        <div className="text-center mb-12">
          <h2 className="text-3xl font-sans font-bold mb-2 text-primary">Quem é o Dr. Guthyerres Carvalho</h2>
          <div className="w-24 h-1 bg-secondary mx-auto mb-6"></div>
        </div>
        
        <div className="flex flex-col lg:flex-row gap-12 items-stretch">
          <div className="lg:w-1/2 flex flex-col justify-between">
            <div>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed text-center md:text-left">
                Dr. Guthyerres Carvalho Santos é médico com formação em Medicina Esportiva e atuação de excelência nas áreas de emagrecimento, tratamento hormonal, menopausa e lipedema.
              </p>
              
              <p className="text-lg text-gray-700 mb-6 leading-relaxed text-center md:text-left">
                Reconhecido por abordagem ampla que vai além dos sintomas, considerando a história de vida, os aspectos metabólicos, emocionais e comportamentais de cada paciente.
              </p>
              
              <p className="text-lg text-gray-700 mb-6 leading-relaxed text-center md:text-left">
                Sua prática baseada em evidências oferece soluções eficazes, seguras e sustentáveis — com resultados reais e duradouros. Ao longo dos anos, tem transformado a trajetória de saúde e qualidade de vida de centenas de pacientes, além de receber e treinar médicos que desejam aprofundar seus conhecimentos em performance, hormônios e emagrecimento.
              </p>
            </div>
            
            <div className="bg-secondary/10 p-6 rounded-lg shadow-soft mb-6">
              <p className="text-lg text-gray-700 leading-relaxed font-semibold text-center md:text-left">
                Com suas estratégias de mentoria, Dr. Guthyerres já ajudou outros médicos a chegarem nos 100 mil de faturamento pela primeira vez, transformando suas práticas clínicas e resultados financeiros.
              </p>
              <div className="text-center mt-4">
                <a 
                  href="https://pt.surveymonkey.com/r/R7CD6CV"
                  target="_blank" rel="noopener noreferrer"
                  className="inline-block bg-secondary hover:bg-secondary-light text-primary-dark font-bold py-2 px-6 rounded-full text-center transition-colors duration-300 shadow-soft"
                >
                  Saiba mais sobre a Mentoria
                </a>
              </div>
            </div>
            
            <div className="space-y-4">
              <div className="bg-neutral-light p-6 rounded-lg shadow-soft">
                <h3 className="text-xl font-sans font-semibold mb-4 text-primary text-center">Áreas de Atuação</h3>
                
                <div className="grid grid-cols-2 gap-4">
                  <div className="flex items-center">
                    <div className="w-3 h-3 rounded-full bg-secondary mr-3"></div>
                    <span className="text-gray-700">Emagrecimento</span>
                  </div>
                  
                  <div className="flex items-center">
                    <div className="w-3 h-3 rounded-full bg-secondary mr-3"></div>
                    <span className="text-gray-700">Reposição Hormonal</span>
                  </div>
                  
                  <div className="flex items-center">
                    <div className="w-3 h-3 rounded-full bg-secondary mr-3"></div>
                    <span className="text-gray-700">Tratamento de Lipedema</span>
                  </div>
                  
                  <div className="flex items-center">
                    <div className="w-3 h-3 rounded-full bg-secondary mr-3"></div>
                    <span className="text-gray-700">Medicina Esportiva</span>
                  </div>
                  
                  <div className="flex items-center">
                    <div className="w-3 h-3 rounded-full bg-secondary mr-3"></div>
                    <span className="text-gray-700">Menopausa</span>
                  </div>
                  
                  <div className="flex items-center">
                    <div className="w-3 h-3 rounded-full bg-secondary mr-3"></div>
                    <span className="text-gray-700">Qualidade de Vida</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="lg:w-1/2 flex items-stretch">
            <div className="relative w-full h-full">
              <div className="absolute inset-0 bg-primary rounded-lg opacity-10 transform translate-x-4 translate-y-4"></div>
              <img 
                src={require("../assets/images/about/imagem2.png")} 
                alt="Dr. Guthyerres Carvalho em evento médico" 
                className="rounded-lg shadow-medium relative z-10 w-full h-full object-contain md:object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;


